export default __webpack_public_path__ + "static/media/ER-GK60-S421-1.3f1ce3df.jpg";